import type { AuthUser } from '@/context/AuthContext';
import { userRoleDisplay } from './enums';

const MISSING = '—';

export interface AccountView {
  initials: string;
  name: string;
  email: string;
  firm: string;
  role: string;
}

/** First letters of the first and last word, uppercased; one word gives one letter. */
export function toInitials(name: string): string {
  const words = name.trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return MISSING;
  const first = words[0];
  const last = words[words.length - 1];
  const letters = words.length === 1 ? first.charAt(0) : first.charAt(0) + last.charAt(0);
  return letters.toUpperCase();
}

/** `GET /api/auth/me` carries no phone, company or join date, so only these fields exist. */
export function toAccountView(user: AuthUser): AccountView {
  const name = user.name.trim();
  return {
    initials: toInitials(user.name),
    name: name || MISSING,
    email: user.email || MISSING,
    firm: user.firm?.name || MISSING,
    role: user.role ? userRoleDisplay(user.role).label : MISSING,
  };
}
